class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartNotif = this.closest("cart-notification");
      const prodCard = this.closest(".cart-notification-product");

      // Optimistic instant delete: smoothly collapse the item right away without blocking UI
      if (prodCard) {
        prodCard.style.pointerEvents = "none";
        prodCard.style.transition = "opacity 0.2s ease, transform 0.2s ease, max-height 0.25s ease, margin 0.25s ease, padding 0.25s ease";
        prodCard.style.opacity = "0";
        prodCard.style.transform = "translateX(25px)";
        prodCard.style.maxHeight = prodCard.offsetHeight + "px";
        setTimeout(() => {
          prodCard.style.maxHeight = "0";
          prodCard.style.paddingTop = "0";
          prodCard.style.paddingBottom = "0";
          prodCard.style.marginTop = "0";
          prodCard.style.marginBottom = "0";
          prodCard.style.overflow = "hidden";
        }, 30);
      }

      const drawer = document.getElementById("mini-cart-drawer");
      if (drawer) drawer.classList.add("loading-bar");

      if (cartNotif) {
        cartNotif.deleteQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("mini-cart-drawer");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );

      this.notification.addEventListener("click", (event) => {
        if (!event.target.closest(".cart-notification__close")) return;
        this.close();
      });
    }

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    window.addEventListener("popstate", () => {
      if (this.notification && this.notification.classList.contains("active")) {
        this.close(true);
      }
    });

    window.addEventListener("pageshow", () => {
      document.querySelector("body")?.classList.remove("added__overlay");
    });
  }

  onChange(event) {
    if (
      !event.target.closest("select") &&
      !event.target.closest('[name="attributes[gift-wrapping]"]') &&
      !event.target.closest('[name="note"]') &&
      !event.target.closest("shipping-calculator") &&
      !event.target.closest("discount-code") &&
      !event.target.closest("gift-wrap-message")
    ) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
      document
        .querySelector(".cart_action_drawer_overlay")
        .classList.add("active");
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    if (!window.history.state?.cartDrawerOpen) {
      window.history.pushState({ cartDrawerOpen: true }, "", window.location.href);
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close(fromPopstate = false) {
    if (typeof window.SSPSMiniCartClose === "function") {
      window.SSPSMiniCartClose(fromPopstate);
    } else {
      document.getElementById("mini-cart-drawer")?.classList.remove("active", "animate");
      document.querySelector("body")?.classList.remove("added__overlay");
      if (!fromPopstate && window.history.state?.cartDrawerOpen) {
        window.history.back();
      }
    }

    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState, openDrawer = false) {
    const miniCartSection = document.getElementById("mini-cart-drawer");
    if (miniCartSection && parsedState.sections && parsedState.sections["mini-cart-drawer"]) {
      miniCartSection.innerHTML = this.getSectionInnerHTML(
        parsedState.sections["mini-cart-drawer"]
      );
    }

    let countHtml = "";
    if (parsedState.sections && parsedState.sections["cart-notification-count"]) {
      countHtml = this.getSectionInnerHTML(
        parsedState.sections["cart-notification-count"]
      ).trim();
    } else if (parsedState.item_count !== undefined) {
      countHtml = String(parsedState.item_count);
    }

    if (countHtml !== "") {
      if (window.SSPSCartFeedback?.updateCount) {
        window.SSPSCartFeedback.updateCount(countHtml);
      } else {
      const allCountBadges = document.querySelectorAll(
        "#cart-notification-count, #cart-notification-count-mobile, .mobile__nav-badge, .cart-count-bubble"
      );
      allCountBadges.forEach((badge) => {
        badge.innerHTML = countHtml;
        if (Number(countHtml) > 0) {
          badge.style.display = "";
          badge.classList.remove("d-none");
        }
      });
      }
    }

    if (this.header) this.header.reveal();
    if (openDrawer) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart-drawer",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart update failed: ${response.status}`);
        }
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error("Malformed cart update response:", e);
          return;
        }
        this.renderContents(parsedState);
        if (parsedState.item_count > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
      })
      .catch((e) => {
        console.error("Cart update error:", e);
      })
      .finally(() => {
        const overlay = document.querySelector(".cart_action_drawer_overlay");
        if (overlay) overlay.classList.remove("active");
        if (this.notification) this.notification.classList.remove("loading-bar");
      });
  }
  updateLiveRegions(line, itemCount) {
    const errorEl = document.getElementById(`Line-item-error-${line}`);
    const qtyInput = document.getElementById(`Quantity-${line}`);
    if (this.currentItemCount === itemCount && errorEl && qtyInput) {
      const errorText = errorEl.querySelector(".cart-item__error-text");
      if (errorText) {
        errorText.textContent = (window.cartStrings?.quantityError || "").replace(
          "[quantity]",
          qtyInput.value
        );
      }
      errorEl.classList.remove("no-js-inline");
    } else if (errorEl) {
      errorEl.classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart delete failed: ${response.status}`);
        }
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error("Malformed cart delete response:", e);
          return;
        }
        this.renderContents(parsedState);
      })
      .catch((e) => {
        console.error("Cart delete error:", e);
      })
      .finally(() => {
        const overlay = document.querySelector(".cart_action_drawer_overlay");
        if (overlay) overlay.classList.remove("active");
        if (this.notification) this.notification.classList.remove("loading-bar");
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : "";
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

window.SSPSMiniCartClose = function (fromPopstate = false) {
  const drawer = document.getElementById("mini-cart-drawer");
  if (drawer) {
    drawer.classList.remove("active", "animate");
  }
  const cartNotif = document.querySelector("cart-notification");
  if (cartNotif) {
    cartNotif.classList.remove("active");
  }
  document.body.classList.remove("added__overlay");
  const overlay = document.querySelector(".cart_action_drawer_overlay");
  if (overlay) overlay.classList.remove("active");

  if (!fromPopstate && window.history.state?.cartDrawerOpen) {
    window.history.back();
  }
  const cartBtn = document.querySelector(".header__actions_btn--cart");
  if (cartBtn && typeof removeTrapFocus === "function") removeTrapFocus(cartBtn);
};

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      // Cart icons link to the full cart page. Keep that navigation intact.
      if (event.target.closest('a[href*="/cart"]')) return;
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("mini-cart-drawer");

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.miniCartClose()
      );
    }
  }

  onClickMiniCart() {
    this.notification = this.notification || document.getElementById("mini-cart-drawer");
    if (!this.notification) return;
    this.notification.classList.add("animate", "active");
    const cartNotif = this.notification.closest("cart-notification");
    if (cartNotif) cartNotif.classList.add("active");
    document.body.classList.add("added__overlay");

    if (!window.history.state?.cartDrawerOpen) {
      window.history.pushState({ cartDrawerOpen: true }, "", window.location.href);
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );
  }

  miniCartClose(fromPopstate = false) {
    if (typeof window.SSPSMiniCartClose === "function") {
      window.SSPSMiniCartClose(fromPopstate);
    } else {
      this.notification = this.notification || document.getElementById("mini-cart-drawer");
      if (this.notification) {
        this.notification.classList.remove("active", "animate");
      }
      document.body.classList.remove("added__overlay");
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);

// Global click listeners for Cart Close and Backdrop Tap
document.addEventListener("click", function (event) {
  const closeBtn = event.target.closest(
    ".cart-notification__close, [data-cart-close], .mini__cart--close__btn, .cart-drawer-close"
  );
  if (closeBtn) {
    event.preventDefault();
    if (typeof window.SSPSMiniCartClose === "function") {
      window.SSPSMiniCartClose();
    }
    return;
  }

  if (document.body.classList.contains("added__overlay")) {
    const target = event.target;
    if (
      !target.closest("#mini-cart-drawer") &&
      !target.closest("cart-notification") &&
      !target.closest("open-minicart") &&
      !target.closest(".header__actions_btn--cart") &&
      !target.closest("#quickViewWrapper")
    ) {
      if (typeof window.SSPSMiniCartClose === "function") {
        window.SSPSMiniCartClose();
      }
    }
  }
});
